import { render, staticRenderFns } from "./EnlaceMenu.vue?vue&type=template&id=0765cb32&scoped=true&"
import script from "./EnlaceMenu.vue?vue&type=script&lang=js&"
export * from "./EnlaceMenu.vue?vue&type=script&lang=js&"
import style0 from "./EnlaceMenu.vue?vue&type=style&index=0&id=0765cb32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0765cb32",
  null
  
)

export default component.exports